// Hook pobierający listę użytkowników klienta handlowca (tradera).
// GET /api/ui/sales-crm/clients/{clientId}/users

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import {
  ICommandResponseError as IError,
  IPaginationRequest,
  IPaginationResponse
} from 'api/types';

export interface ISalesCrmClientUserListItem {
  id: number;
  first_name: string | null;
  last_name: string | null;
  email: string | null;
  /** Rola usera: 1 = ROLE_USER_MAIN (glowny user klienta), 2 = ROLE_USER (zwykly user klienta). */
  role_id?: number | null;
  role_formatted?: string | null;
  /** @deprecated UZYJ `role_id === 1` zamiast `is_main`. Pole zachowane dla wstecznej kompatybilnosci. */
  is_main?: boolean;
}

type IRequest = IPaginationRequest;
type IResponse = IPaginationResponse<ISalesCrmClientUserListItem>;

const getSalesCrmClientUsers = (clientId: number, params?: IRequest): Promise<IResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/users`, { params });

export const useGetSalesCrmClientUsers = (
  clientId: number,
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['sales-crm-client-users', clientId, params],
    () => getSalesCrmClientUsers(clientId, params),
    options
  );
